module.exports = __webpack_public_path__ + "static/img/pic_ketang@2x.e1b9708a.png";